module.exports = __webpack_public_path__ + "img/Frame_s5_b0_9x9_1_TTT_UK.02efdc81.png";